import { KnmDataViolationPathsTemplateEnum } from 'APIPackage/KnmModule/enums/KnmDataViolationPathsTemplateEnum';
import {
  CHECKLISTS_TITLE_BLOCK_ID,
  DURATION_DAYS_BLOCK_ID,
  DURATION_HOURS_BLOCK_ID,
  EVENTS_BLOCK_ID,
  IMPOSSIBLE_CONDUCTION_REASON_BLOCK_ID,
  INN_LABEL_BLOCK_ID,
  INSPECTION_TARGET_LABEL_BLOCK_ID,
  INSPECTORS_TITLE_ID,
  KIND_BLOCK_ID,
  KNO_ORGANIZATION_BLOCK_ID,
  KNO_ORGANIZATION_FUNCTIONS_TITLE_ID,
  LEGAL_BASES_TITLE_ID,
  NOTICE_DATE_BLOCK_ID,
  NOTICE_METHOD_BLOCK_ID,
  OBJECTS_BLOCK_ID,
  OBJECTS_RESULTS_TITLE_BLOCK_ID,
  OGRN_LABEL_BLOCK_ID,
  ORDER_NUMBER_BLOCK_ID,
  ORGANIZATION_NAME_BLOCK_ID,
  REQUIREMENTS_TITLE_BLOCK_ID,
  START_DATE_BLOCK_ID,
  STOP_DATE_BLOCK_ID,
  SUPERVISION_TYPE_BLOCK_ID,
  TYPE_BLOCK_ID,
  VIOLATIONS_LAWSUITS_TITLE_BLOCK_ID,
} from 'KnmPackage/MainModule/constants/fieldsElementsIds';

interface IMenuViolationData {
  title: string;
  scrollElementId: string;
}

export const menuViolationsDataByPathMap: Record<KnmDataViolationPathsTemplateEnum[number], IMenuViolationData> = {
  [KnmDataViolationPathsTemplateEnum.TYPE]: {
    title: 'Характер КНМ',
    scrollElementId: TYPE_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.KIND]: {
    title: 'Вид КНМ',
    scrollElementId: KIND_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.ATR]: {
    title: 'Номер приказа',
    scrollElementId: ORDER_NUMBER_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.DATE]: {
    title: 'Дата приказа',
    scrollElementId: 'orderDate',
  },
  [KnmDataViolationPathsTemplateEnum.START_DATE]: {
    title: 'Дата начала КНМ',
    scrollElementId: START_DATE_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.STOP_DATE]: {
    title: 'Дата окончания КНМ',
    scrollElementId: STOP_DATE_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.LEGAL_BASES]: {
    title: 'Правовые основания проведения КНМ',
    scrollElementId: LEGAL_BASES_TITLE_ID,
  },
  [KnmDataViolationPathsTemplateEnum.LEGAL_BASES_ITEM]: {
    title: 'Правовые основания проведения КНМ',
    scrollElementId: LEGAL_BASES_TITLE_ID,
  },
  [KnmDataViolationPathsTemplateEnum.INSPECTION_TARGET]: {
    title: 'Цели, задачи, предмет КНМ',
    scrollElementId: INSPECTION_TARGET_LABEL_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.DURATION_DAYS]: {
    title: 'Срок проведения (дней)',
    scrollElementId: DURATION_DAYS_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.DURATION_HOURS]: {
    title: 'Срок проведения (часов)',
    scrollElementId: DURATION_HOURS_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.EVENTS]: {
    title: 'Перечень мероприятий по контролю, необходимых для достижения целей и задач проведения КНМ',
    scrollElementId: EVENTS_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.EVENTS_ITEM]: {
    title: 'Перечень мероприятий по контролю, необходимых для достижения целей и задач проведения КНМ',
    scrollElementId: EVENTS_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.KNO_ORGANIZATION]: {
    title: 'Наименование органа контроля',
    scrollElementId: KNO_ORGANIZATION_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.FUNCTIONS]: {
    title:
      'Указание на реестровый номер функции в федеральной государственной информационной системе Федеральный реестр государственных и муниципальных услуг (функции)',
    scrollElementId: KNO_ORGANIZATION_FUNCTIONS_TITLE_ID,
  },
  [KnmDataViolationPathsTemplateEnum.FUNCTIONS_ITEM]: {
    title:
      'Указание на реестровый номер функции в федеральной государственной информационной системе Федеральный реестр государственных и муниципальных услуг (функции)',
    scrollElementId: KNO_ORGANIZATION_FUNCTIONS_TITLE_ID,
  },
  [KnmDataViolationPathsTemplateEnum.INSPECTORS]: {
    title: 'Уполномоченные на проведение проверки',
    scrollElementId: INSPECTORS_TITLE_ID,
  },
  [KnmDataViolationPathsTemplateEnum.INSPECTORS_ITEM]: {
    title: 'Уполномоченные на проведение проверки',
    scrollElementId: INSPECTORS_TITLE_ID,
  },
  [KnmDataViolationPathsTemplateEnum.SUPERVISION_TYPE]: {
    title: 'Вид государственного контроля (надзора)',
    scrollElementId: SUPERVISION_TYPE_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.INN]: {
    title: 'Идентификационный номер налогоплательщика (ИНН)',
    scrollElementId: INN_LABEL_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.OGRN]: {
    title: 'Основной государственный регистрационный номер (ОГРН)',
    scrollElementId: OGRN_LABEL_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.NAME]: {
    title: 'Наименование проверяемого лица',
    scrollElementId: ORGANIZATION_NAME_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.OBJECTS]: {
    title: 'Объекты проведения КНМ',
    scrollElementId: OBJECTS_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.OBJECTS_ITEM]: {
    title: 'Объекты проведения КНМ',
    scrollElementId: OBJECTS_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.SUPERVISIONS]: {
    title: 'Вид (виды) контроля (надзора)',
    scrollElementId: OBJECTS_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.NOTICE_METHOD]: {
    title: 'Способ уведомления',
    scrollElementId: NOTICE_METHOD_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.NOTICE_DATE]: {
    title: 'Дата уведомления',
    scrollElementId: NOTICE_DATE_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.RESULT]: {
    title: 'Результат объекта проведения КНМ',
    scrollElementId: OBJECTS_RESULTS_TITLE_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.RESULT_ACT_CREATE_DATE]: {
    title: 'Дата и время составления акта о проведении КНМ',
    scrollElementId: OBJECTS_RESULTS_TITLE_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.RESULT_ADDITIONAL_INFO]: {
    title: 'Сведения о результатах проведения КНМ',
    scrollElementId: OBJECTS_RESULTS_TITLE_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.RESULT_ADDITIONAL_INFO_ITEM]: {
    title: 'Сведения о результатах проведения КНМ',
    scrollElementId: OBJECTS_RESULTS_TITLE_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.RESULT_DELEGATES]: {
    title: 'Должностное лицо, присутствовавшее при проведении КНМ',
    scrollElementId: OBJECTS_RESULTS_TITLE_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.RESULT_DELEGATES_ITEM]: {
    title: 'Должностное лицо, присутствовавшее при проведении КНМ',
    scrollElementId: OBJECTS_RESULTS_TITLE_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.RESULT_DURATION_DAYS]: {
    title: 'Продолжительность проведения КНМ (Дней) по результату',
    scrollElementId: OBJECTS_RESULTS_TITLE_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.RESULT_DURATION_HOURS]: {
    title: 'Продолжительность проведения КНМ (Часов) по результату',
    scrollElementId: OBJECTS_RESULTS_TITLE_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.RESULT_INSPECTORS]: {
    title: 'Должностное лицо, проводившее КНМ',
    scrollElementId: OBJECTS_RESULTS_TITLE_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.RESULT_INSPECTORS_ITEM]: {
    title: 'Должностное лицо, проводившее КНМ',
    scrollElementId: OBJECTS_RESULTS_TITLE_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.RESULT_START_DATE]: {
    title: 'Дата и время проведения КНМ',
    scrollElementId: OBJECTS_RESULTS_TITLE_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.CHECKLISTS]: {
    title: 'Проверочные листы',
    scrollElementId: CHECKLISTS_TITLE_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.IMPOSSIBLE_CONDUCTION_REASON]: {
    title: 'Сведения о причинах невозможности проведения КНМ',
    scrollElementId: IMPOSSIBLE_CONDUCTION_REASON_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.REQUIREMENTS]: {
    title: 'Обязательные требования',
    scrollElementId: REQUIREMENTS_TITLE_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.REQUIREMENTS_ITEM]: {
    title: 'Обязательные требования',
    scrollElementId: REQUIREMENTS_TITLE_BLOCK_ID,
  },
  [KnmDataViolationPathsTemplateEnum.LAWSUITS]: {
    title: 'Меры, принятые по результатам КНМ',
    scrollElementId: VIOLATIONS_LAWSUITS_TITLE_BLOCK_ID,
  },
};
